import { gConsts } from './gConsts';
import store from '../store/store';
import profiler from './Profiler';

const state   = store.state;
const getters = store.getters;

export const nodes = {    
    getNode(nodeId) { 
        return getters.GET_projNodes?.get(nodeId);
    },
    getNodeLabel(nodeId) { 
        return nodes.getNode(nodeId)?.layout.label ?? '';
    },
    getNodeParent(nodeId) {        
        let node = nodes.getNode(nodeId);
        return nodes.getNode(node?.layout.parent);
    },
    isSearchableLabel(node) {
        let parent = getters.GET_projNodes?.get(node.layout.parent);
        return ( (node.layout.type == gConsts.node.layout.types.LABEL                                              ) && 
                 ([gConsts.node.layout.groups.FOLDER, gConsts.node.layout.groups.SET].includes(parent?.layout.group)) );
    },

    // -----------------------------------------------------------------

    getFilteredLabels() {    
        var filteredLabels, searchTokens, searchStrContainsDiacritics, result, normalizeString;
//        profiler.enter('Method', 'Nodes', 'getFilteredLabels');
//        profiler.profileBlock('Code block', 'Nodes.getFilteredLabels', '[initialization]', () => {
        filteredLabels = [];
        searchTokens = [];
        searchStrContainsDiacritics = false;
        result = [];
//        });       

//        profiler.profileBlock('Code block', 'Nodes.getFilteredLabels', '[filter 1, 2 and 3]', () => {
        // FILTRO 1 - somente labels pesquisaveis/navegaveis
        filteredLabels = getters.GET_nodesArray.filter(node => { 
            return ( 
                nodes.isSearchableLabel(node) 
    
                // FILTRO 2 - (execMode == VIEW) somente labels que foram anotados na imagem (associados a locations)  
                && (getters.GET_execModeVIEW ? getters.GET_labelLocations.has(node.id) : true)

                // FILTRO 3 - ((execMode == VIEW) && (location.hover)) somente labels que estão associados à location ativa
                && ((getters.GET_execModeVIEW && getters.GET_activeDente) 
                    ? getters.GET_labelLocations.get(node.id).includes(getters.GET_activeDente?.label.id) 
                    : true)
            );
        });  
//        });  

//            console.log(`execMode_VIEW : ${getters.GET_execModeVIEW}, activeDente: ${getters.GET_activeDente}`);
        if (getters.GET_nodeSearchStr == '') { 
//            profiler.exit();
            return filteredLabels; 
        }

//        profiler.profileBlock('Code block', 'Nodes.getFilteredLabels', '[prepare tokens]', () => {
        normalizeString = (str) => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

        // Check if the search term contains diacritical marks
        searchStrContainsDiacritics = getters.GET_nodeSearchStr.normalize("NFD") !== normalizeString(getters.GET_nodeSearchStr);

        // Escape special characters for regex, and split the search term into tokens
        searchTokens = getters.GET_nodeSearchStr
            .trim()
            .toLowerCase()
            .split(/\s+/)
            .map(token => searchStrContainsDiacritics ? token : normalizeString(token))
            .map(token => token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')); // Escape regex special characters
//        });

//        profiler.profileBlock('Code block', 'Nodes.getFilteredLabels', '[filter 4]', () => {
        // FILTRO 4 - Filtrar por nodeSearchStr (conditionally accent-sensitive comparison)
        result = filteredLabels.filter(node => {
            const nodeCaption = searchStrContainsDiacritics 
                ? node.layout.caption.toLowerCase() 
                : normalizeString(node.layout.caption.toLowerCase());

            // Check that all tokens match at the beginning of a word in the caption
            return searchTokens.every(token => {
                const regex = new RegExp(`(^|\\s)${token}`, 'i');
                return regex.test(nodeCaption);
            });
        });
//        });

        profiler.exit();
//        console.log(`getFilteredLabels execution: ${profiler.groups.getFilteredLabels.run}`);

        return result;
    },

    // -----------------------------------------------------------------



    /*
        Activates the [node] (ancerstors, node and firstDescendants) based on avaiable 
        nodes in the [nodeArray] argument
    */
    activateNode(node, nodeArray) {
        var ancestors, firstDescendants, activeNodes, payload;

        ancestors = nodes.getNodeAncestors(node, getters.GET_projNodes);
        firstDescendants = nodes.getNodeFirstDescendants(node, nodeArray);

        activeNodes = [...ancestors, node, ...firstDescendants];
        console.log("activateNode.activeNodes: ", JSON.stringify(activeNodes));
        payload = { active : { nodes : new Map(activeNodes.map(node => [node.id, node])) } }

        activeNodes.forEach(activeNode => {
            switch (activeNode.layout.type) {
                case gConsts.node.layout.types.LABEL : 
                    payload.active['label'] = activeNode.id; 
                    payload.active['layer'] = activeNode.layout.parent;
                    break;
                case gConsts.node.layout.types.STEP : 
                    payload.active['step'] = activeNode.id; 
                    break;                
            }
        });

        console.log(`activateNode: ${JSON.stringify(payload.active)}`);

        store.dispatch('ACT_runtimeUpdate', payload);
    },
    
    // -----------------------------------------------------------------

    isNodeActive(node) { return (getters.GET_activeNodes?.has(node.id)); },

    // -----------------------------------------------------------------

    // Navigates to the next/previous label (based on inc) and activates it as the current label
    labelNav(inc) {
        var newActiveLabel = null,
            currActiveLabelIndex = getters.GET_filteredNodes.findIndex(label => label.id == getters.GET_activeLabel);

        if (currActiveLabelIndex == -1) {
            const filteredLabels = nodes.getFilteredLabels();
            newActiveLabel = filteredLabels.length > 0 ? filteredLabels[0] : null;
        } else if ( ((currActiveLabelIndex + inc) < getters.GET_filteredNodes.length) && ((currActiveLabelIndex + inc) >= 0) ) {
            newActiveLabel = getters.GET_filteredNodes[currActiveLabelIndex + inc];
        }

        if (newActiveLabel) {
            nodes.activateNode(newActiveLabel, getters.GET_filteredNodes);
        }
    },    

    // -----------------------------------------------------------------

    // Get node's children using only nodes from nodeArray
    getNodeChildren(node, nodeArray) {
        return nodeArray.filter(childNode => (childNode.layout.parent === node.id));
    },

    // -----------------------------------------------------------------

    // Get node's ancestors until ROOT
    getNodeAncestors(node, nodeMap) {
        var nodeParent,
            ancestors = [];

        nodeParent = nodeMap.get(node.layout.parent);
        while (nodeParent) {
            ancestors.push(nodeParent);
            nodeParent = nodeMap.get(nodeParent.layout.parent);
        }

        return ancestors;
    },

    // -----------------------------------------------------------------

    getNodesAncestors(nodeArray) { 
        var nodeAncestors,
            nodesAncestors = new Set();

        nodeArray.forEach(node => {
            nodeAncestors = nodes.getNodeAncestors(node, getters.GET_projNodes);
            nodeAncestors.forEach(node => nodesAncestors.add(node));
        });

        return nodesAncestors;
    },

    // -----------------------------------------------------------------

    // Get node's first descendants using only nodes from nodeArray
    getNodeFirstDescendants(node, nodeArray) {
        var firstDescendant, children,
            firstDescendants = [];

        children = nodes.getNodeChildren(node, nodeArray);
        while (children.length > 0) {
            firstDescendant = children[0];
            firstDescendants.push(firstDescendant);
            children = nodes.getNodeChildren(firstDescendant, nodeArray);
        }

        return firstDescendants;
    }

    // -----------------------------------------------------------------
}
    
